<template>
  <a
    v-if="to"
    :href="linkUrl"
    :target="target"
    :class="classes"
    @click.exact="handleClickItem($event, false)"
    @click.ctrl="handleClickItem($event, true)"
    @click.meta="handleClickItem($event, true)"
    :style="itemStyle"
    ><slot></slot
  ></a>
  <li v-else :class="classes" @click.stop="handleClickItem" :style="itemStyle">
    <div :class="iconClass"></div>
    <slot></slot>
  </li>
</template>
<script>
import Emitter from "iview/src/mixins/emitter";
import { findComponentUpward } from "iview/src/utils/assist";
import mixinsLink from "iview/src/mixins/link";

const prefixCls = "bottom-navigation";

export default {
  name: "BottomNavigationItem",
  mixins: [Emitter, mixinsLink],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    iconClass: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}-item`,
        {
          [`${prefixCls}-item-active`]: this.active,
          [`${prefixCls}-item-selected`]: this.active,
          [`${prefixCls}-item-disabled`]: this.disabled
        }
      ];
    },
    itemStyle() {
      return {
        paddingLeft: 43 + (this.parentSubmenuNum - 1) * 24 + "px"
      };
    }
  },
  methods: {
    handleClickItem(event, new_window = false) {
      if (this.disabled) return;

      if (new_window || this.target === "_blank") {
        // 如果是 new_window，直接新开窗口就行，无需发送状态
        this.handleCheckClick(event, new_window);
        let parentMenu = findComponentUpward(this, "BottomNavigation");
        if (parentMenu) parentMenu.handleEmitSelectEvent(this.name);
      } else {
        this.dispatch("BottomNavigation", "on-bottom-navigation-item-select", this.name);

        this.handleCheckClick(event, new_window);
      }
    }
  },
  mounted() {
    this.$on("on-update-active-name", name => {
      if (this.name === name) {
        this.active = true;
        this.dispatch("BottomNavigation", "on-update-active-name", name);
      } else {
        this.active = false;
      }
    });
  }
};
</script>